// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2FNxt","infoBtn":"quickbooks_infoBtn__2Kxtf","formBox":"quickbooks_formBox__2ho0s","formFooter":"quickbooks_formFooter__1Z8In"};